<template>
  <div class="main-content">
    <div class="card">
      <div class="card-header">
        <h5>Заявки {{ tabName }}</h5>
      </div>
      <div class="card-body">
        <h6 v-if="$route.params.orderId">
          Заявка
          <strong
          ><a
            href="#"
            @click="
                mixinGoToRouter('editOrder', { id: $route.params.orderId })
              "
          >{{ $route.params.orderId }}</a
          ></strong
          >
          создана
        </h6>
        <div class="tabs tabs-simple">
          <ul class="nav nav-tabs" role="tablist" v-if="enabledTabs">
            <li class="nav-item">
              <a
                @click="getOrdersByType(ordersTypes.manual)"
                class="nav-link active"
                data-toggle="tab"
                href="#manual"
                role="tab"
              >Ручные</a
              >
            </li>
            <li class="nav-item">
              <a
                @click="getOrdersByType(ordersTypes.delivery)"
                class="nav-link"
                data-toggle="tab"
                href="#delivery"
                role="tab"
              >Доставочные</a
              >
            </li>
            <li class="nav-item">
              <a
                @click="getOrdersByType(ordersTypes.post)"
                class="nav-link"
                data-toggle="tab"
                href="#post"
                role="tab"
              >Почтовые</a
              >
            </li>
          </ul>
          <div class="tab-content">
            <div class="tab-pane active" id="manual" role="tabpanel">
              <div class="flex ago_text_block">
                <div class="ago_text">
                  <span class="m-r-10" v-if="$OrdersList[0]"
                  >Всего: <strong>{{ $OrdersList[0].length }}</strong></span
                  >
                  Обновлено:
                  <time-ago
                    refresh
                    :datetime="refreshTime[ordersTypes.manual]"
                    locale="ru"
                    long
                    tooltip="true"
                  ></time-ago>
                </div>
                <div>
                  <vue-ladda
                    @click="getOrdersByType(ordersTypes.manual, true)"
                    button-class="btn btn-sm btn-info"
                    data-style="zoom-in"
                    :loading="refreshing[ordersTypes.manual]"
                  >Обновить
                  </vue-ladda>
                </div>
              </div>
              <div>
                <pulse-loader
                  :loading="loading[0]"
                  :color="loadingColor"
                  class="text-center"
                />
              </div>
              <ordersList
                ref="manualOrdersList"
                v-if="$OrdersList[0] && !loading[0]"
                :orders="$OrdersList[0]"
                :projects="projects"
                :cities="cities"
                :subStatuses="subStatuses"
                displayType="manager"
                orderType="manual"
                :fetchOrders="fetchOrders"
              />
              <div v-if="$OrdersList[0]">
                <vue-ladda
                  @click="sendOrders()"
                  button-class="btn btn-success"
                  data-style="zoom-in"
                  :loading="allSendLoading"
                >Отправить выбранные
                </vue-ladda>
              </div>
            </div>
            <div class="tab-pane" id="delivery" role="tabpanel">
              <div class="flex ago_text_block">
                <div v-if="newOrders[1]" class="ago_text">
                  Новых:
                  <span class="badge badge-success">{{ newOrders[1].new }}</span>
                </div>
                <div class="ago_text">
                  <span class="m-r-10" v-if="newOrders[1]?.total"
                  >Всего: <strong>{{ newOrders[1].total }}</strong></span
                  >
                  Обновлено:
                  <time-ago
                    refresh
                    :datetime="refreshTime[ordersTypes.delivery]"
                    locale="ru"
                    long
                    tooltip="true"
                  ></time-ago>
                </div>
                <div>
                  <vue-ladda
                    @click="getOrdersByType(ordersTypes.delivery, true)"
                    button-class="btn btn-sm btn-info"
                    data-style="zoom-in"
                    :loading="refreshing[ordersTypes.delivery]"
                  >Обновить
                  </vue-ladda>
                </div>
              </div>
              <div>
                <pulse-loader
                  :loading="loading[1]"
                  :color="loadingColor"
                  class="text-center"
                />
              </div>
              <ordersList
                v-if="$OrdersList[1] && !loading[1]"
                :orders="$OrdersList[1]"
                :projects="projects"
                :cities="cities"
                :subStatuses="subStatuses"
                displayType="manager"
                :updateOrders="updateOrders"
              />
              <div class="text-right">
                <paginate v-if="paginator"
                          v-model="paginator.current_page"
                          :page-count="paginator.last_page"
                          :page-range="3"
                          :margin-pages="2"
                          :click-handler="(page) => getOrdersByType(1, true, page)"
                          :prev-text="'&laquo'"
                          :next-text="'&raquo'"
                          :container-class="'pagination'"
                          :prev-class="'page-item'"
                          :prev-link-class="'page-link'"
                          :page-class="'page-item'"
                          :page-link-class="'page-link'"
                          :next-class="'page-item'"
                          :next-link-class="'page-link'"
                          :active-class="'active green_btn'">
                </paginate>
              </div>

            </div>
            <div class="tab-pane" id="post" role="tabpanel">
              <div class="flex ago_text_block">
                <div v-if="newOrders[2]" class="ago_text">
                  Новых:
                  <span class="badge badge-success">{{ newOrders[2] }}</span>
                </div>
                <div class="ago_text">
                  <span class="m-r-10" v-if="$OrdersList[2]"
                  ><span></span>Всего:
                    <strong>{{ $OrdersList[2].length }}</strong></span
                  >
                  Обновлено:
                  <time-ago
                    refresh
                    :datetime="refreshTime[ordersTypes.post]"
                    locale="ru"
                    long
                    tooltip="true"
                  ></time-ago>
                </div>
                <div>
                  <vue-ladda
                    @click="getOrdersByType(ordersTypes.post, true)"
                    button-class="btn btn-sm btn-info"
                    data-style="zoom-in"
                    :loading="refreshing[ordersTypes.post]"
                  >Обновить
                  </vue-ladda>
                </div>
              </div>
              <div>
                <pulse-loader
                  :loading="loading[2]"
                  :color="loadingColor"
                  class="text-center"
                />
              </div>
              <ordersList
                v-if="$OrdersList[2] && !loading[2]"
                :orders="$OrdersList[2]"
                :projects="projects"
                :cities="cities"
                :subStatuses="subStatuses"
                displayType="manager"
              />
              <div class="text-right">
                <paginate v-if="paginator"
                          v-model="paginator.current_page"
                          :page-count="paginator.last_page"
                          :page-range="10"
                          :margin-pages="3"
                          :click-handler="(page) => getOrdersByType(2, true, page)"
                          :prev-text="'&laquo'"
                          :next-text="'&raquo'"
                          :container-class="'pagination'"
                          :prev-class="'page-item'"
                          :prev-link-class="'page-link'"
                          :page-class="'page-item'"
                          :page-link-class="'page-link'"
                          :next-class="'page-item'"
                          :next-link-class="'page-link'"
                          :active-class="'active green_btn'">
                </paginate>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import ordersList from "@/components/orders/ordersList";
import TimeAgo from "vue2-timeago";
import VueLadda from "vue-ladda/src/vue-ladda.vue";
import moment from "moment";
import $ from "jquery";
import Paginate from 'vuejs-paginate'

export default {
  components: {
    ordersList,
    TimeAgo,
    Paginate,
    VueLadda,
  },
  data() {
    return {
      paginator: null,
      allSendLoading: false,
      tabName: null,
      enabledTabs: false,
      orders: {
        0: null,
        1: null,
        2: null
      },
      loading: {
        0: false,
        1: false,
        2: false
      },
      loadingColor: "#007dcc",
      deliveryOrders: null,
      postOrders: null,
      ordersTypes: {
        manual: 0,
        delivery: 1,
        post: 2
      },
      refreshing: {
        0: false,
        1: false,
        2: false
      },
      refreshTime: {
        0: moment().format("YYYY-MM-DD HH:mm"),
        1: moment().format("YYYY-MM-DD HH:mm"),
        2: moment().format("YYYY-MM-DD HH:mm")
      },
      newOrders: {},
      projects: null,
      cities: null,
      subStatuses: null
    };
  },
  computed: {
    $OrdersList() {
      return this.$store.getters["orders/ordersList"];
    },
    $callBackActions() {
      return this.$store.getters['platform/callBackActions']
    },
  },
  mounted() {
    this.getOrdersData();
    this.updatePageByRoute(this.$route.name, true);
    // this.getOrdersByType(this.ordersTypes.manual);
  },
  watch: {
    $route(to, from) {
      this.updatePageByRoute(to.name);
    },
    $callBackActions(e) {
      console.log(e);
      if (e && e.action) {
        switch (e.action) {
          case 'refreshList':
            console.log('update');
            this.getOrdersByType(this.ordersTypes.manual, true);
            break;
        }
        this.$store.dispatch('platform/setCallBackActions', null);
      }
    }
  },
  methods: {
    fetchOrders() {
    },
    async sendOrders() {
      this.allSendLoading = true;
      let selected = Object.keys(this.$refs.manualOrdersList.selected).filter(
        key => {
          if (this.$refs.manualOrdersList.selected[key].value) {
            return {orderId: key};
          }
        }
      );
      if (selected.length) {
        let {data} = await api.post("/new/orders/sendManyOrders", {
          selectedOrders: selected
        });
        if (data.success) {
          toastr["success"]("Заявки отправлены");
          this.getOrdersByType(this.ordersTypes.manual, true);
        } else {
          toastr["warning"](data.message);
        }
      } else {
        toastr["warning"]("Заявки не выбраны");
      }

      this.allSendLoading = false;
    },
    updateOrders(type, orders) {
      this.orders[this.ordersTypes[type]] = orders;
    },
    updatePageByRoute(name, force = false) {
      console.log(name);
      this.enabledTabs = false;

      $(".tab-pane").removeClass("active");

      switch (name) {
        case "listOrders":
          this.tabName = null;
          $("#manual").addClass("active");
          this.getOrdersByType(this.ordersTypes.manual, force);
          this.enabledTabs = true;
          break;
        case "listOrdersDelivery":
          this.tabName = "(Доставочные)";
          $("#delivery").addClass("active");
          this.getOrdersByType(this.ordersTypes.delivery, force);
          break;
        case "listOrdersManual":
          this.tabName = "(Ручные)";
          $("#manual").addClass("active");
          this.getOrdersByType(this.ordersTypes.manual, force);
          break;
        case "listOrdersPost":
          this.tabName = "(Почтовые)";
          $("#post").addClass("active");
          this.getOrdersByType(this.ordersTypes.post, force);
          break;
        default:
          break;
      }
    },
    async getOrdersData() {
      let {data} = await api.index("/orders/getOrdersData");
      this.projects = data.projects;
      this.cities = data.cities;
      this.subStatuses = data.subStatuses;
    },
    async getOrdersByType(type, force = false, page = 1) {
      if (this.$OrdersList[type] && this.$OrdersList[type].length && !force) {
        return;
      }

      this.refreshing[type] = true;

      this.orders[type] = null;
      this.loading[type] = true;

      let {data: r_data} = await api.index("/orders/getOrdersByType/" + type + '?page=' + page);
      if (r_data.success) {
        const {data, ...pagination} = r_data.records
        this.paginator = pagination;
        this.orders[type] = data;
        let allOrders = typeof this.$OrdersList === 'object' ? {...this.$OrdersList} : {};
        allOrders[type] = data;
        this.$store.dispatch("orders/setOrdersFilter", {typeAlias: Object.keys(this.ordersTypes).find((t) => this.ordersTypes[t] === type)});
        this.$store.dispatch("orders/setOrdersList", {...allOrders});

        if (!this.newOrders[type]) this.$set(this.newOrders, type, {new: 0, total: 0});
        else this.newOrders[type] = {new: 0, total: 0};

        this.newOrders[type] = {new: pagination.total, total: pagination.total};
        // data.forEach(o => {
        //   if (o.sub_status == 0) ++this.newOrders[type];
        // });
      }

      this.loading[type] = false;
      this.refreshTime[type] = moment().format("YYYY-MM-DD HH:mm");
      this.refreshing[type] = false;
    }
  }
};
</script>

<style>
.ago_text .badge {
  color: white;
  font-size: 15px;
}
</style>

<style scoped>
.flex.ago_text_block {
  justify-content: flex-end;
  margin-top: -10px;
  margin-bottom: 15px;
}

.ago_text_block .ago_text {
  padding-top: 8px;
  margin-right: 10px;
}
</style>
